import { useMemo, useState } from 'react';
import { Joyride, ACTIONS, EVENTS, STATUS } from 'react-joyride';

const TOUR_VERSION = 'v1';

const InitialTourComponent = ({ steps = [], userId }) => {
    const storageKey = useMemo(
        () => `freeliefs_tour_${TOUR_VERSION}_completed_${userId || 'guest'}`,
        [userId]
    );

    const [run, setRun] = useState(() => localStorage.getItem(storageKey) !== 'true');
    const [stepIndex, setStepIndex] = useState(0);

    const joyrideSteps = useMemo(
        () =>
            (steps || []).map((step) => ({
                target: step.target,
                title: step.title,
                content: step.content,
                placement: step.placement || 'auto',
                disableBeacon: true,
            })),
        [steps]
    );

    const handleCallback = (data) => {
        const { action, index, status, type } = data;
        const markTourAsCompleted = () => {
            localStorage.setItem(storageKey, 'true');
            setRun(false);
        };

        if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
            markTourAsCompleted();
            return;
        }

        if (action === ACTIONS.CLOSE) {
            markTourAsCompleted();
            return;
        }

        if (type === EVENTS.TARGET_NOT_FOUND) {
            setStepIndex(index + 1);
            return;
        }

        if (type === EVENTS.STEP_AFTER) {
            const nextIndex = index + (action === ACTIONS.PREV ? -1 : 1);
            setStepIndex(nextIndex);
        }
    };

    if (!joyrideSteps.length || !run) {
        return null;
    }

    return (
        <Joyride
            onEvent={handleCallback}
            continuous
            disableCloseOnEsc
            hideCloseButton
            run={run}
            scrollToFirstStep
            showSkipButton
            stepIndex={stepIndex}
            steps={joyrideSteps}
            locale={{
                back: 'Voltar',
                close: 'Fechar',
                last: 'Terminar',
                next: 'Próximo',
                skip: 'Pular',
            }}
            styles={{
                options: {
                    primaryColor: '#2f855a',
                    zIndex: 1200,
                },
            }}
        />
    );
};

export default InitialTourComponent;